import { Divider, Tabs } from 'antd';
import React from 'react';
import NapsaComponent from './NapsaTab';
import NhimaComponent from './NhimaTab';
import OtherComponent from './OthersTab';
import PayeComponent from './PayeTab';
import WorkerCompensationComponent from './WorkerCompensation';
import styles from './index.module.scss';
import './index.scss';

const StatutoryComponent = () => {
	const [activeKey, setActiveKey] = React.useState('napsa');
	const changeTab = (key: any) => {
		setActiveKey(key);
	};

	let tabItems = [
		{
			key: 'napsa',
			label: 'NAPSA',
			children: (
				<NapsaComponent
					changeTab={changeTab}
					activeKey={activeKey}
					fetchLatestNapsaData
				/>
			),
		},
		{
			key: 'nhima',
			label: 'NHIMA',
			children: (
				<NhimaComponent changeTab={changeTab} activeKey={activeKey} />
			),
		},
		{
			key: 'paye',
			label: 'PAYE',
			children: (
				<>
					<PayeComponent
						changeTab={changeTab}
						activeKey={activeKey}
					/>
					<Divider
						dashed
						style={{ borderColor: '#BCBCBC', marginBottom: '4rem' }}
					></Divider>
					<OtherComponent />
				</>
			),
		},
		{
			key: 'worker-compensation',
			label: 'Workers compensation',
			children: (
				<WorkerCompensationComponent
					changeTab={changeTab}
					activeKey={activeKey}
				/>
			),
		},
	];

	return (
		<div className={styles['statutory-component']}>
			<div className="statutory-component-tabs">
				<Tabs
					defaultActiveKey={activeKey}
					activeKey={activeKey}
					destroyInactiveTabPane={true}
					items={tabItems}
					onChange={(key) => changeTab(key)}
					style={{
						fontSize: '18px',
						marginBottom: '40px',
					}}
				/>
			</div>
		</div>
	);
};

export default StatutoryComponent;
